import React, {PureComponent} from 'react';

import { Intent, PopoverInteractionKind, Position, Popover } from '@blueprintjs/core/lib/esm/index';
import toastr from 'toastr';
import { getJwt } from '../../../services/authService';
import http from '../../../services/httpService';
import EditTagModal from '../../modals/EditTagModal';
import UpdateCardDateModal from '../../modals/UpdateCardDateModal';

class SinglePaymentMethod extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            popoverOpen: undefined,
            projectDefaultLoader: false,
            deletePaymentMethodLoader: false,
            showUpdateCardModal: false
        };
    }

    getCardLogo = () => {
        let brand = this.props.method.card_brand

        return brand === 'visa' ? '/img/cards/payment-methods/visa.png' : brand === 'mastercard' ? '/img/cards/payment-methods/master-card.png' :
            brand === 'discover' ? '/img/cards/payment-methods/discover.png' : brand === 'amex' ? '/img/cards/payment-methods/amex.png' :
                '/img/cards/payment-methods/default.png'
    }

    setProjectDefault = async () => {
        let user = await this.props.user;
        let projectId = await localStorage.source_clicked ? JSON.parse(localStorage.source_clicked) : '';
        this.setState({
            projectDefaultLoader: true
        })
        if (projectId.toString() === this.props.method.project_id.toString()){
            try{
                // Called when some project payment method is set
                const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/default_payment_method_project',{"pm_id": this.props.method.id}, {headers: {authorization: getJwt()}});
                this.props.updateMethodsList()
            }catch(e){
                toastr.error("Couldn't set payment method as default, please try again.")
            }
        } else if(this.props.type === 'other'){
            try{
                // Called when credit card from other available payment methods is selected
                const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',{"pm_id": this.props.method.id}, {headers: {authorization: getJwt()}});
                this.props.updateMethodsList()
            }catch(e){
                toastr.error("Couldn't set payment method as default, please try again.")
            }
        }else if(this.props.method.project_id){
            try{
                // Called when there are no default payment method
                const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/use_existing_payment_method',{"pm_id": this.props.method.id}, {headers: {authorization: getJwt()}});
                if(result.data === 'THIS WORKSPACE ALREADY HAS A DEFAULT PAYMENT METHOD'){
                    toastr.error("THIS WORKSPACE ALREADY HAS A DEFAULT PAYMENT METHOD")
                }
                this.props.updateMethodsList()
            }catch(e){
                toastr.error("Couldn't set payment method as default, please try again.")
            }
        }

        this.setState({
            projectDefaultLoader: false
        })
    }

    deletePaymentMethod = async () => {
        let user = await this.props.user;
        let projectId = await JSON.parse(localStorage.source_clicked);
        this.setState({
            deletePaymentMethodLoader: true
        })
        if (projectId.toString() === this.props.method.project_id.toString()){
            try {
                const result = await http.delete('/api/user/' + user.id + '/project/' + projectId + '/pm/' + this.props.method.id, {headers: {authorization: getJwt()}});
                if (result.data && result.data.error){
                    toastr.error(result.data.message)
                }
                this.props.updateMethodsList()
            } catch(e) {
                toastr.error("Payment Method couldn't be deleted")
            }
        }
        // } else if(this.props.type === 'other'){
        //     try{
        //         const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/oa_payment_method_customer',{"pm_id": this.props.method.id});
        //         this.props.updateMethodsList()
        //     }catch(e){
        //         toastr.error("Couldn't set payment method as default, please try again.")
        //     }
        // }else if(this.props.method.project_id){
        //     try{
        //         const result = await http.post('/api/user/' + user.id + '/project/' + projectId + '/customers/use_existing_payment_method',{"pm_id": this.props.method.id});
        //         if(result.data === 'THIS PROJECT ALREADY HAS A DEFAULT PAYMENT METHOD'){
        //             toastr.error("THIS PROJECT ALREADY HAS A DEFAULT PAYMENT METHOD")
        //         }
        //         this.props.updateMethodsList()
        //     }catch(e){
        //         toastr.error("Couldn't set payment method as default, please try again.")
        //     }
        // }

        this.setState({
            deletePaymentMethodLoader: false
        })
    }

    getThreeMonthsAhead = () =>{
        let today = new Date();
        let threeMonthsAgo = today;
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() + 3)
        return threeMonthsAgo
    }

    handleUpdate = () => {
        this.setState({showUpdateCardModal: true, popoverOpen: false})
        setTimeout( () => {
            this.setState({popoverOpen: undefined})
        }, 500)
    }


    render() {
        let endDate = this.props.method.ends_at;
        let date = endDate.substring(0, 4);
        let month = endDate.substring(5,7);
        let day = endDate.substring(8,10);
        let today = new Date();
        let threeMonthsAhead = this.getThreeMonthsAhead();
        let expired = new Date(date, month, day) < today;
        let expiringSoon = new Date(date, month, day) < threeMonthsAhead;
        let subscription_renewal_problem = this.props.subscription_renewal_problem;

        return (
            <div className='single-payment-method-relative-container'>
                <div className='single-payment-method-container'>
                    <div className='image-name-container'>
                        <img src={this.getCardLogo()} />
                        <div className='name-card-container'>
                            <p className='card-number'>**** **** **** {this.props.method.card_last_four}</p>
                            <p className='card-name'>{this.props.method.billing_details ? this.props.method.billing_details.billing_name : 'No billing name'}</p>
                        </div>
                        <div className='date-card-container'>
                            <p className='card-number'>{this.props.method && this.props.method.ends_at ?
                                (this.props.method.ends_at.substring(5,7)+'/'+this.props.method.ends_at.substring(2,4)) : ''}</p>
                            <p className={expired ? 'card-expired' : 'card-expires-soon'}>{expired ? 'expired' : expiringSoon ? 'expiring soon' : ''}</p>
                        </div>
                    </div>
                    {this.props.type === 'other' || this.props.type === 'paymentError' ? '' :
                        <div className='default-container'>
                            {this.props.method.project_default ?
                                <div className='default-button'>Default</div>
                                :
                                ''
                            }
                        </div>
                    }
                    {/*{ this.props.type === 'other' ? '' :*/}
                    {this.props.type === 'paymentError' ?
                        ''
                        :
                        <Popover
                            interactionKind={ PopoverInteractionKind.CLICK }
                           
                            className='flex-direction-row'
                            position={ Position.LEFT_TOP }
                            minimal={ true }
                            isOpen={this.state.popoverOpen}
                            canOutsideClickClose={ true }
                        >
                            <span id="feed-edit" className="fas fa-ellipsis-v"></span>
                            <div className="project-info-popover padding-10">
                                { expired || this.props.method.project_default ?
                                    <p className='disabled'>Make Workspace Default</p>
                                    :
                                    <p onClick={ this.setProjectDefault }>Make Workspace Default { this.state.projectDefaultLoader ?
                                        <i className='fa fa-spin fa-spinner'></i> : '' }</p>
                                }
                                {
                                    expired ?
                                        <p onClick={this.handleUpdate}>Update</p>
                                        :
                                        <p className="disabled">Update</p>
                                }

                                { this.props.method.project_default || this.props.type === 'other' ?
                                    <p className='disabled'>Delete</p>
                                    :
                                    <p onClick={ this.deletePaymentMethod }>Delete { this.state.deletePaymentMethodLoader ?
                                        <i className='fa fa-spin fa-spinner'></i> : '' }</p>
                                }
                            </div>
                        </Popover>
                    }
                    {/*}*/}
                </div>
                {/*{console.log('Use this card: ', subscription_renewal_problem, !expired, !this.props.method.project_default, this.props.method)}*/}
                { subscription_renewal_problem && !expired && (!this.props.method.project_default || this.props.type === 'other') ?
                    <button className='btn-transparent-border use-this-card-btn'>Use This Card</button>
                    :
                    ''
                }
                <UpdateCardDateModal
                    showModal={this.state.showUpdateCardModal}
                    handleClose={() => this.setState({showUpdateCardModal: false})}
                    method={this.props.method}
                    selectedSource={this.props.selectedSource}
                    maxWidth={600}
                    history={this.props.history}
                    user={this.props.user}
                    updatePaymentMethods={this.props.updatePaymentMethods}
                    handleGetTags={this.props.handleGetTags}
                    month={this.props.method ? this.props.method.ends_at.substring(5,7) : ''}
                    year={this.props.method ? this.props.method.ends_at.substring(0,4) : ''}
                />
            </div>
        )
    }
}

export default SinglePaymentMethod;